import { render, staticRenderFns } from "./estudiantes.vue?vue&type=template&id=162a71d3&scoped=true"
import script from "./estudiantes.vue?vue&type=script&lang=js"
export * from "./estudiantes.vue?vue&type=script&lang=js"
import style0 from "./estudiantes.vue?vue&type=style&index=0&id=162a71d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162a71d3",
  null
  
)

export default component.exports